<!-- <perfect-scrollbar
    (psScrollLeft)="onScrolled($event)"
    (psScrollRight)="onScrolled($event)"
    >
    <div (scroll)="onScrolled($event)"> -->
<div #scrollBar (scrollEmitter)="onScrolled($event)" [ngStyle]="{'width': '100%'}">
  <ng-content></ng-content>
</div>
<!-- </div>

  </perfect-scrollbar> -->
